import type {
  ChecklistItem,
  ChecklistStatus,
  InFieldUser,
} from '@cognite/apm-client';
import type { NodeDefinition } from '@cognite/sdk';
import type { SolutionTag } from '@cognite/solution-tags';

export enum MissingChecklistsState {
  NONE = 'NONE',
  SEARCHING_MISSING_CHECKLISTS = 'SEARCHING_MISSING_CHECKLISTS',
  CHECKLISTS_CREATED = 'CHECKLISTS_CREATED',
  NO_MISSING_CHECKLISTS = 'NO_MISSING_CHECKLISTS',
  MISSING_CHECKLISTS = 'MISSING_CHECKLISTS',
  CREATING_CHECKLISTS = 'CREATING_CHECKLISTS',
  FAILED_TO_CREATE_CHECKLISTS = 'FAILED_TO_CREATE_CHECKLISTS',
}

export type SchedulerNode = Pick<NodeDefinition, 'externalId' | 'space'>;

export type SchedulerSolutionTag = Omit<SolutionTag, 'name'> &
  Partial<Pick<SolutionTag, 'name'>>;

export type SchedulerChecklist = {
  title?: string;
  status?: ChecklistStatus;
  solutionTags?: SchedulerSolutionTag[];
  externalId: string;
  sourceId?: string;
  startTime?: string;
  endTime?: string;
  createdBy?: InFieldUser;
  assignedTo?: string[];
  nextOccurrence?: string;
  checklistItems?: ChecklistItem[];
};

export type DataGridChecklist = SchedulerChecklist & {
  id: string;
  day?: string;
  createdByExternalId?: string;
};

export type DataGridChecklistLeafRow = DataGridChecklist & {
  hierarchy: string[];
  isDayGroup?: false;
};

export type DataGridChecklistGroupRow = {
  id: string;
  externalId: string;
  day: string;
  hierarchy: string[];
  isDayGroup: true;
  groupSize: number;
};

export type DataGridChecklistTreeRow =
  | DataGridChecklistLeafRow
  | DataGridChecklistGroupRow;

export type SchedulerFailedInfoboxData = {
  createdChecklists: number;
  plannedChecklists: number;
};

// TODO(FO-3151): Change back to 'cdm' once the infield cdm system data model is ready
export type SchedulerDataModelFlag = 'cdm_experimental' | 'apm';
